import { ApiBase } from '@/api/methods/ApiBase'

export namespace ReconfigureMailAddressesApi {
  /**
   * メールアドレス情報登録API
   *
   * @param mailAddress メールアドレス
   */
  export async function applyNewAddress(mailAddress: string): Promise<void> {
    const params = {
      mailAddress: mailAddress,
    }
    await ApiBase.post('/reconfigureMailAddress', params)
  }

  /**
   * メールアドレス更新API
   *
   * @param token トークン
   */
  export async function updateMailAddress(token: string): Promise<void> {
    const params = {
      token: token,
    }
    await ApiBase.post('/reconfigureMailAddress/update', params)
  }
}
